import { useMutation, useQuery } from '@tanstack/react-query';
import { getPaymentReq, paymentReq, cancelSubscriptionReq, pauseSubscriptionReq, resumeSubscriptionReq } from '../api';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Notification from '../../components/Notification';

export const usePaymentQuery = () => {
    const dispatch = useDispatch();
    const { isLoading, data } = useQuery({
        queryKey: ['get-payment'],
        queryFn: async () => {
            try {
                const response = await getPaymentReq();
                return response;
            } catch (error) {
                // toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
                console.error('Error fetching categories:', error);
                throw error;
            }
        },
        retry: false,
        refetchOnWindowFocus: false,
    });

    return { isLoading, data };
};

export const usePaymentMutation = () => {
    return useMutation({
        mutationKey: ['check-answer'],
        mutationFn: async (data) => {
            const response = await paymentReq({...data});
            return response.data;
        },
        onSuccess: (data) => {
            if (data?.checkout_url) {
                window.open(data.checkout_url, "_blank", "noopener,noreferrer");
            }
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const useCancelPaymentMutation = () => {
    return useMutation({
        mutationKey: ['cancel-subscription'],
        mutationFn: async () => {
            const response = await cancelSubscriptionReq();
            return response.data;
        },
        onSuccess: (data) => {
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const usePausePaymentMutation = () => {
    return useMutation({
        mutationKey: ['pause-subscription'],
        mutationFn: async () => {
            const response = await pauseSubscriptionReq();
            return response.data;
        },
        onSuccess: (data) => {
            
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const useResumePaymentMutation = () => {
    return useMutation({
        mutationKey: ['resume-subscription'],
        mutationFn: async () => {
            const response = await resumeSubscriptionReq();
            return response.data;
        },
        onSuccess: (data) => {
            
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};
